import en from './en.json';
import es from './es.json';
import i18n, { i18n as i18nType } from 'i18next';
import { doEn, doEs } from 'client-experience-toolbox';

export const resources = {
  en: { common: { ...doEn, ...en.common } },
  es: { common: { ...doEs, ...es.common } },
};

export const loadDOLanguageResources = (i18nFromShell: i18nType) => {
  i18nFromShell.addResourceBundle('en', 'common', resources.en.common, false, true);
  i18nFromShell.addResourceBundle('es', 'common', resources.es.common, false, true);
};

// only use this for unit tests
export const initializeI18nForUnitTest = () => {
  i18n.init({
    resources,
    defaultNS: 'common',
    fallbackLng: 'en',
  });
  return i18n;
};

export type SupportedLanguages = keyof typeof resources;
